export type BannerAdType =
    | 'standard' // 320x50
    | 'large' // 320x100
    | 'full' // 468x60
    | 'mediumRectangle' // 300x250
    | 'leaderboard' // 728x90
    | 'dynamic' // Screen width x 50
    | 'dynamicLeaderboard'; // Screen width x 90
